import supabase from '../lib/supabase';

export async function fetchUserProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('display_name')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data;
}

export async function fetchUserVoterIdentity() {
  const { data, error } = await supabase.rpc('get_user_voter_identity');
  if (error) throw error;
  return data;
}

export async function changeLockedCountry(oldCountry, newCountry) {
  const { data, error } = await supabase.rpc('change_locked_country', {
    p_old_country: oldCountry,
    p_new_country: newCountry,
  });

  if (error) throw error;
  return data;
}

export async function fetchUserVoteHistory() {
  const { data, error } = await supabase.rpc('get_user_vote_history');
  if (error) throw error;
  return data ?? [];
}

export function parseProfileRpcError(error) {
  const message = error?.message ?? '';
  if (message.includes('NOT_AUTHENTICATED')) return 'not_authenticated';
  if (message.includes('IDENTITY_NOT_FOUND')) return 'identity_not_found';
  if (message.includes('OLD_COUNTRY_MISMATCH')) return 'old_country_mismatch';
  if (message.includes('DUPLICATE_COUNTRY')) return 'duplicate_country';
  if (message.includes('INVALID_COUNTRY')) return 'invalid_country';
  return 'unknown';
}
